class HeroTestimonial extends HTMLElement {
    constructor() {
        super();
        this.currentIndex = 0;
    }

    connectedCallback() {
        this.handleResize = () => this.initialiseComponent();

        this.initialiseComponent();
        this.attachEventListeners();

        window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
    }

    initialiseComponent() {
        this.scroller = this.querySelector('.home-testimonial__scroller');

        this.slider = this.querySelector('.home-testimonial__slider');
        if (!this.slider) return;

        this.cards = Array.from(this.querySelectorAll('.home-testimonial__card'));
        if (this.cards.length === 0) return;

        this.arrows = Array.from(this.querySelectorAll('.home-testimonial__arrow'));
        if (!this.arrows || this.arrows.length !== 2) return;


        if (this.cards.length > 1) {
            this.sliderGap =
                (this.slider.scrollWidth -
                    this.cards.length * this.cards[0].clientWidth) /
                (this.cards.length - 1);
        } else {
            this.sliderGap = 0;
        }
    }

    attachEventListeners() {
        if (!this.arrows || this.arrows.length !== 2) return;

        this.arrows[0].addEventListener('click', () => this.slideBy(-1));
        this.arrows[1].addEventListener('click', () => this.slideBy(1));
    }

    slideBy(modifier) {
        if (!this.slider || !this.cards.length) return;

        const visibleCount = this.getVisibleCount();
        const maxIndex = this.cards.length - visibleCount;

        this.currentIndex += modifier;

        if (this.currentIndex < 0) this.currentIndex = 0;
        if (this.currentIndex > maxIndex) this.currentIndex = maxIndex;

        // Disable arrows properly
        this.arrows[0].disabled = this.currentIndex === 0;
        this.arrows[1].disabled = this.currentIndex >= maxIndex;

        const cardWidth = this.cards[0].clientWidth + (this.sliderGap || 0);

        this.slider.scrollTo({
            left: this.currentIndex * cardWidth,
            behavior: 'smooth'
        });
    }

    getVisibleCount() {
        if (!this.slider || !this.cards.length) return 1;

        const sliderWidth = this.slider.clientWidth;
        const cardWidth = this.cards[0].clientWidth + (this.sliderGap || 0);

        return Math.round(sliderWidth / cardWidth) || 1;
    }
}

if (!customElements.get('hero-testimonial')) {
    customElements.define('hero-testimonial', HeroTestimonial);
}